import React from "react";
import { Dialog } from "Components";
import useSearch from "../../hooks/useSearch";
import { MyInsightsSearch } from "../../types";

type DeleteSearchProps = {
  search: MyInsightsSearch;
  isOpen: boolean;
  onClose: () => void;
};

const DeleteSearch = ({
  search,
  isOpen,
  onClose,
}: DeleteSearchProps): React.JSX.Element => {
  const { handleDeleteSearch } = useSearch();

  return (
    <Dialog
      title="Delete search"
      confirmText="Delete"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={async () => {
        await handleDeleteSearch(search);

        onClose();
      }}
    >
      <p>
        Are you sure you want to delete <b>{search.name}</b> search?
      </p>
      <p>The search will be deleted immediately.</p>
    </Dialog>
  );
};

export default DeleteSearch;
